import { MapTo } from '@adobe/aem-react-editable-components';
import PlasticCardDesign, { PlasticCardDesignEditConfig } from './PlasticCardDesign';

export default MapTo('cob-corp-acquisition/components/creditonebank/plastic-card-design')(PlasticCardDesign, PlasticCardDesignEditConfig);